import { v4 as uuid } from "uuid";

import { IDashboardLayout } from "@formant/core/model/IDashboardLayout";

interface IModulesNodesMap {
    modules: Record<string, string>;
    nodes: Record<string, string>;
}

export const calculateCount = (screenWidth: number) => {
    const baseWidth = 2560;
    const baseCount = 25;
    const proportionalCount = (screenWidth / baseWidth) * baseCount;
    return Math.round(proportionalCount);
};

export const regenerateIds = (data: IDashboardLayout): IDashboardLayout => {
    const idMap: IModulesNodesMap = {
        modules: {},
        nodes: {},
    };
    for (const oldModuleId of Object.keys(data.modules)) {
        idMap.modules[oldModuleId] = uuid();
    }
    const updatedModules: Record<string, any> = {};
    for (const [oldModuleId, module] of Object.entries(data.modules)) {
        const newModuleId = idMap.modules[oldModuleId];
        const newGraph = { ...module.graph };
        newGraph.id = newModuleId;

        newGraph.nodes = module.graph.nodes.map((node: any) => {
            const newNodeId = uuid();
            idMap.nodes[node.id] = newNodeId;
            return {
                ...node,
                id: newNodeId,
                group: node.group.replace(oldModuleId, newModuleId),
            };
        });

        newGraph.edges = module.graph.edges.map((edge: any) => {
            return {
                from: {
                    node: idMap.nodes[edge.from.node],
                    output: edge.from.output,
                },
                to: {
                    node: idMap.nodes[edge.to.node],
                    input: edge.to.input,
                },
            };
        });

        updatedModules[newModuleId] = {
            ...module,
            graph: newGraph,
            x: module.x,
            y: module.y,
            width: module.width,
            height: module.height,
        };
    }

    return {
        modules: updatedModules,
        timelineVisible: data.timelineVisible,
        aggregateTimeRange: { ...data.aggregateTimeRange },
    } as IDashboardLayout;
};

export const sortColumnMapper: Record<string, string> = {
    Device: "name",
};

export const availableSortNames = ["id", "name", "type", "tags", "enabled"];

export const getSortParam = (
    columnName: string | undefined,
): string | undefined => {
    const sortNameParams = sortColumnMapper[columnName || ""];
    if (availableSortNames.indexOf(sortNameParams || "") > -1) {
        return sortNameParams;
    }
    return undefined;
};
